import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './main/_components/page-not-found/page-not-found.component';
import { DashboardComponent } from './main/_components/dashboard/dashboard.component';
import { LoginComponent } from './main/_components/login/login.component';
import { LogoutComponent } from './main/_components/logout/logout.component';
import { AuthGuard } from './main/_guards/auth.guard';
import { RegisterComponent } from './main/_components/register/register.component';
import { ActivateComponent } from './main/_components/activate/activate.component';
import { TestSchedulerComponent } from './test-scheduler/test-scheduler.component';
var ɵ0 = {
    roles: ['P'],
    is_wizard: false
}, ɵ1 = {
    roles: ['P'],
    is_wizard: true
}, ɵ2 = {
    roles: ['D'],
    is_wizard: false
}, ɵ3 = {
    roles: ['P'],
    is_wizard: false
}, ɵ4 = {
    roles: ['P'],
    is_wizard: false
}, ɵ5 = {
    roles: ['P'],
    is_wizard: false
}, ɵ6 = {
    roles: ['P'],
    is_wizard: false
}, ɵ7 = {
    roles: ['P'],
    is_wizard: false
}, ɵ8 = {
    roles: ['P'],
    is_wizard: false
};
var routes = [
    // lazy loads
    {
        path: 'services', loadChildren: './services/services.module#ServicesModule', canActivate: [AuthGuard],
        data: ɵ0
    },
    {
        path: 'wizard', loadChildren: './wizard/wizard.module#WizardModule', canActivate: [AuthGuard],
        data: ɵ1
    },
    {
        path: 'driver-app', loadChildren: './driver-app/driver-app.module#DriverAppModule', canActivate: [AuthGuard],
        data: ɵ2
    },
    {
        path: 'pricelists', loadChildren: './pricelists/pricelists.module#PricelistsModule', canActivate: [AuthGuard],
        data: ɵ3
    },
    {
        path: 'scheduler', loadChildren: './scheduler/scheduler.module#SchedulerModule', canActivate: [AuthGuard],
        data: ɵ4
    },
    {
        path: 'network', loadChildren: './network/network.module#NetworkModule', canActivate: [AuthGuard],
        data: ɵ5
    },
    {
        path: 'customers', loadChildren: './customers/customers.module#CustomersModule', canActivate: [AuthGuard],
        data: ɵ6
    },
    {
        path: 'account', loadChildren: './account/account.module#AccountModule', canActivate: [AuthGuard],
        data: ɵ7
    },
    // standard
    {
        path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard],
        data: ɵ8
    },
    { path: 'login', component: LoginComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'activate/:token', component: ActivateComponent },
    { path: 'logout', component: LogoutComponent },
    { path: 'test-scheduler', component: TestSchedulerComponent },
    // default
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    // wild card route
    { path: '**', component: PageNotFoundComponent }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8 };
